import axios from "axios";
import { BACKEND_URL, CATALOGO_MENSAJES } from "../shared/constants";
import { JWT_HEADER } from "../shared/functions";


export default {
  /*
   * Ejecuta el metodo post al servicio requerido
   * @param {string} controller ubicación del controlador
   * @param {string} method metodo asociado al controlador
   * @param {FormData|Raw|JSON} data parametros enviados al servicio 
   */
  post: async (controller, method, data, config = {}) => {
    const URL = `${BACKEND_URL}/${controller}/${method}`;
    return await axios.post(URL, data, { ...JWT_HEADER(), ...config });
  },

  postFile: async (controller, method, data, config = {}) => {
    const URL = `${BACKEND_URL}/${controller}/${method}`;
    config = {
        ...config, // Mantiene cualquier configuración existente
        responseType: 'blob', // Agrega responseType
        ...JWT_HEADER() // Agrega los encabezados JWT
    };
    return await axios.post(URL, data,config);
  },

  /*SOLO para iniciar session */
  postLogIn: async (controller, method, data, config = {}) => {
    const URL = `${BACKEND_URL}/${controller}/${method}`; 
    return await axios.post(URL, data, { ...JWT_HEADER(true), ...config });
  },

  /*
   * Ejecuta el metodo get al servicio requerido
   * @param {string} controller ubicación del controlador
   * @param {string} method metodo asociado al controlador 
   */
  get: async (controller, method, config = {}) => {
    const URL = `${BACKEND_URL}/${controller}/${method}`;
    return await axios.get(URL, { ...JWT_HEADER(), ...config });
  },
  delete: async (controller, method, config = {}) => {
    const URL = `${BACKEND_URL}/${controller}/${method}`;
    return await axios.delete(URL, { ...JWT_HEADER(), ...config });
  },
  put: async (controller, method, data, config = {}) => {
    const URL = `${BACKEND_URL}/${controller}/${method}`;
    return await axios.put(URL, data, { ...JWT_HEADER(), ...config });
  },
  patch: async (controller, method, data, config = {}) => {
    const URL = `${BACKEND_URL}/${controller}/${method}`;
    return await axios.patch(URL, data, { ...JWT_HEADER(), ...config });
  },
  handleCatch: (error) => {
    const response = { success: false };
    if (!error.response || (error.response.status === 404 && !error.response.data.detail)) {
      response.message = CATALOGO_MENSAJES.error404;
    }
    else if (error.response.status === 500) {
      if (error.response.data.detail)
        response.message = error.response.data.detail;
    } else if (error.response.status === 400) {
      if (error.response.data.detail)
        response.message = error.response.data.detail;
    } else if (error.response.status >= 400) {
      let message = '';
      if (Array.isArray(error.response.data.detail)) {
        const detail = error.response.data.detail[0];
        if (detail) {
          message = (detail.msg || '') + ": " + (detail.loc ? detail.loc[1] : '');
        } else {
          message = 'Detalles no disponibles';
        }
      } else if (typeof error.response.data.detail === 'string') {
        message = error.response.data.detail;
      }
      response.message = message;
    }
    return response;
  },

  handleCatchBlob: async (error) => {
    const response = { success: false };
    if (!error.response || error.response.status === 404) {
      // TODO: Hot fix, necesita updatearlo
      if (error.response) {
        try {
          const responseParsed = JSON.parse(await error.response.data.text());
          if (responseParsed.message) response.message = responseParsed.message;
          else response.message = CATALOGO_MENSAJES.error404;
        } catch (e) {
          response.message = CATALOGO_MENSAJES.error404;
        }
      } else {
        response.message = CATALOGO_MENSAJES.error404;
      }
    } else if (error.response.data) {
      if (typeof error.response.data) {
        response.message = error.response.data.detail;
        if (!response.message) {
          const responseParsed = JSON.parse(await error.response.data.text());
          response.message = responseParsed.message;
        }
      } else {
        const responseParsed = JSON.parse(await error.response.data.text());
        response.message = responseParsed.message;
      }
    }
    return response;
  },

  handleCatchWithDetails: (error) => {
    const response = { sucess: false };
    if (!error.response || error.response.status === 404)
      response.message = CATALOGO_MENSAJES.error404;
    else if (error.response.status === 500) {
      if (error.response.data.detail)
        response.message = error.response.data.detail;
    } else if (error.response.status === 400) {
      if (error.response.data.detail) {
        response.message = error.response.data.detail;
      } else if (error.response.data.error) {
        response.message = error.response.data.error.message;
        response.details = error.response.data.error.details;
      }
    }
    return response;
  },

  handleCatchMultiData: (error) => {
    const response = { sucess: false };
    if (!error.response || error.response.status === 404)
      response.message = CATALOGO_MENSAJES.error404;
    else if (error.response.status === 500) {
      if (error.response.data.detail)
        response.message = error.response.data.detail;
    } else if (error.response.status === 400) {
      response.message = error.response.data.detail;
      response.data = error.response.data.data;
    }
    return response;
  },
}; 